"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var InboxRulesFull_1 = require("./components/InboxRulesFull");
var React = require("react");
var isInboxRuleEditDirty_1 = require("./utils/isInboxRuleEditDirty");
var isInboxRuleOptionEditState_1 = require("./actions/helpers/isInboxRuleOptionEditState");
var saveInboxRuleEdit_1 = require("./actions/saveInboxRuleEdit");
var resetInboxRuleEdit_1 = require("./actions/resetInboxRuleEdit");
var InboxRulesOption = {
    key: 'inboxRules',
    titleStringKey: 'optionTitle_inboxRules',
    searchTermsStringKey: 'optionTitle_inboxRules',
    fullOptionFormSettings: {
        render: function () { return React.createElement(InboxRulesFull_1.default, null); },
        isDirty: function () { return isInboxRuleOptionEditState_1.default(); },
        onSave: function () { return saveInboxRuleEdit_1.default(); },
        onDiscard: function () { return resetInboxRuleEdit_1.default(); },
        disableSave: function () { return !isInboxRuleEditDirty_1.default(); },
        hideSaveDiscard: function () {
            return !isInboxRuleOptionEditState_1.default();
        },
    },
};
exports.default = InboxRulesOption;
//# sourceMappingURL=InboxRulesOption.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/mail/owa-inbox-rules-option/lib/InboxRulesOption.js
// module id = 5162
// module chunks = 2